// src/api/safety.js
import api from "./axios";
const BASE = "safety/";

/**
 * 안전문서 통합 저장 (신규 + 수정)
 * papers.Docs + safety_doc_meta 스냅샷을 함께 저장
 * POST /api/safety/txns/save-content/
 * PATCH /api/safety/txns/{dns}/status/
 *
 * @param {Object} payload - 통합 저장 데이터
 * {
 *   project: "PJT001",
 *   form_type: "PLAN" | "RESULT" | "SCAR" | "INCIDENT" | "RISKCHECK",
 *   dns?: "기존 문서 번호" (수정 시),
 *   title: "문서 제목",
 *   doc_type?: "문서 유형 (선택)",
 *   status?: "submit" | "approved" | "rejected" 등,
 *   body_json: { ... }   // SafetyDocMeta.meta에 들어갈 내용
 * }
 */
export async function saveSafetyDoc(payload) {
  const res = await api.post(`${BASE}docs/save/`, payload);
  return res?.data ?? res;
}

/**
 * 안전문서 목록 조회
 * GET /api/safety/txns/
 */
export async function listSafetyDocs(params = {}) {
  const res = await api.get(`${BASE}docs/`, { params });
  return res.data;
}

/**
 * 단일 안전문서 조회 (docs + meta snapshot 함께 반환)
 * GET /api/safety/txns/{dns}/
 */
export async function getSafetyDocDetail(dns) {
  const res = await api.get(`${BASE}docs/${dns}/`, {
    params: { project: localStorage.getItem("projectId") },
  });
  return res.data;
}

/**
 * 안전문서 삭제 (soft delete)
 * PATCH /api/papers/docs/{dns}/soft-delete/
 */
export async function deleteSafetyDoc(dns) {
  const res = await api.patch(`papers/docs/${dns}/soft-delete/`, {
    is_deleted: true,
  });
  return res.data;
}

/**
 * ✅ [NEW] 점검 캘린더 전용 목록 조회
 * GET /api/safety/checklists/?project=PJT001
 */
export async function listSafetyChecklists(params = {}) {
  const res = await api.get(`${BASE}checklists/`, { params });
  return res.data;
}

/**
 * 안전관리 대시보드 요약 (누적 + 월별 통계)
 * GET /api/safety/dashboard/?project=<projectId>
 */
export async function getSafetyDashboard(params = {}) {
  const res = await api.get(`${BASE}dashboard/`, { params });
  return res.data;
}

/**
 * 상태 변경 (결재, 승인, 반려 등)
 */
export async function updateSafetyStatus(dns, status) {
  const res = await api.patch(`${BASE}docs/${dns}/status/`, { status });
  return res.data;
}

/////////////

// 목록 조회
//export const listTxns = (params) =>
//  api.get(BASE, { params }).then((r) => r.data);
// 단건 조회
//export const retrieveTxn = (dns, params) =>
//  api.get(`${BASE}${dns}/`, { params }).then((r) => r.data);

// 삭제
//export const softDeleteTxn = (dns, isDeleted = true) =>
//  api.patch(`${BASE}${dns}/`, { is_deleted: !!isDeleted }).then((r) => r.data);

// 안전점검표
// 목록
export const listChecklists = (params) =>
  api.get("safety/checklists/", { params }).then((r) => r.data);
// 단건
export const retrieveChecklist = (dns, params) =>
  api.get(`safety/docs/${dns}/`, { params }).then((r) => r.data);

/** 첨부 업로드 */
//export const uploadTxnAttachment = (dns, file, version = "1.0") => {
//const form = new FormData();
//form.append("file", file);
// form.append("version", version);
// return api.post(`${BASE}${dns}/upload-attachment/`, form).then((r) => r.data);
//};

/** 첨부 삭제 */
//export const deleteTxnAttachment = (dns) =>
//api.delete(`${BASE}${dns}/delete-attachment/`).then((r) => r.data);

/** 첨부 다운로드 URL */
//export const getTxnDownloadUrl = (dns) =>
//`${api.defaults.baseURL}${BASE}${dns}/download-attachment/`;

/** 사진 여러 장 업로드 (files: File[]) */
export const uploadTxnPhotos = (dns, files) => {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  return api.post(`${BASE}${dns}/upload-photos/`, form).then((r) => r.data);
};
